import { prodOrDevCdnParam } from '@utils/isEnv'

export const austinMapBackground = `https://mandrake-app.b-cdn.net/${prodOrDevCdnParam()}/application/display_elements/map-loader-background.png`
